// Task Status Enum
export const TASK_STATUS = {
    NEW: 'New',
    ACTIVE: 'Active',
    DONE: 'Done',
  };
  
  // Task Priority Enum
  export const TASK_PRIORITY = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
  };

/**
 * Task Model
 * A task can be either free-floating or tied to an agenda item
 */
export class Task {
  constructor({
    id,
    name,
    description = '',
    status = TASK_STATUS.NEW,
    priority = TASK_PRIORITY.MEDIUM,
    assignee = null, // UserProfile
    assignedTo = [], // Array of UserProfile
    agendaId = null, // If null, task is free-floating
    startTime = null, // Optional time binding
    endTime = null, // Optional time binding
    createdAt = new Date(),
    updatedAt = new Date(),
  }) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.status = status;
    this.priority = priority;
    this.assignee = assignee;
    this.assignedTo = assignedTo;
    this.agendaId = agendaId;
    this.startTime = startTime;
    this.endTime = endTime;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromJSON(json) {
    return new Task({
      ...json,
      startTime: json.startTime ? new Date(json.startTime) : null,
      endTime: json.endTime ? new Date(json.endTime) : null,
      createdAt: new Date(json.createdAt),
      updatedAt: new Date(json.updatedAt),
    });
  }

  toJSON() {
    return {
      ...this,
      startTime: this.startTime?.toISOString(),
      endTime: this.endTime?.toISOString(),
      createdAt: this.createdAt.toISOString(),
      updatedAt: this.updatedAt.toISOString(),
    };
  }
}